import CommonEdit from "@/components/common/Edit";
import { singleProp } from "@/interface/dataInterface";
import { FC, useEffect, useState } from "react";
import VehicleForm from "./VehicleForm";
import axiosInstance from "@/utils/axiosInstance";

const VehicleEdit: FC<singleProp> = ({ prop }) => {
    const [formProp, setFormProp] = useState({
        type: "",
        license_plate: "",
        make_id: "",
        identification_vin: "",
        make_model: "",
        make_year: "",
        km_type: "",
        two_tanks: "",
        nickname: "",
        notes: "",
        primary_tank_value: "",
        secondary_tank_value: "",
        tanks: []
    })
    const [otherData, setOtherData] = useState({
        primaryTankId: 0,
        primary_tank_value: 0,
        secondaryTankId: 0, 
        secondary_tank_value: 0
    })

    useEffect(() => {
        const unsub = async () => {
            if (!prop) return;
            const response = await axiosInstance.get(`/vehicles/${prop}`)
            const {type, identification_vin, license_plate, km_type, make_id, make_model, make_year, nickname, notes, vehicle_tanks, two_tanks} = response.data
            const twoTankVal = two_tanks ? "yes" : "no"
            setFormProp({
                type, 
                identification_vin: identification_vin || "", 
                license_plate, km_type, make_id, 
                make_model: make_model || "", make_year, nickname, notes, 
                primary_tank_value: vehicle_tanks[0]?.fuel?.name || "", 
                secondary_tank_value: vehicle_tanks[1]?.fuel?.name || "", two_tanks: twoTankVal, tanks: []
            })
            if (vehicle_tanks[0]) {
                setOtherData(prev => {
                    return {
                        ...prev,
                        primaryTankId: vehicle_tanks[0].fuel_id,
                        primary_tank_value: vehicle_tanks[0].unit_capacity
                    }
                })
            }
            if (vehicle_tanks[1]) {
                setOtherData(prev => {
                    return {
                        ...prev,
                        secondaryTankId: vehicle_tanks[1].fuel_id,
                        secondary_tank_value: vehicle_tanks[1].unit_capacity
                    }
                })
            }
        }

        unsub()
    }, [prop])

return (
    <CommonEdit id={prop} resource="vehicles" data={{
        data: {
            ...formProp,
            make_id: Number(formProp.make_id),
            two_tanks: formProp.two_tanks === 'yes' ? true : false,
            license_plate: formProp.license_plate.toUpperCase()
        },
        tanks: [
            otherData.primaryTankId && {
                fuel_id: Number(otherData.primaryTankId),
                unit_capacity: otherData.primary_tank_value,
                type: "PRIMARY"
            },
            otherData.secondaryTankId && {
                fuel_id: Number(otherData.secondaryTankId),
                unit_capacity: otherData.secondary_tank_value,
                type: "SECONDARY"
            }
        ].filter(Boolean),
    }} title="Edit">
        <VehicleForm
            formProp={formProp}
            setFormProp={setFormProp}
            otherData={otherData}
            setOtherData={setOtherData}
            // vehicleType={vehicleType}
            // setVehicleType={setVehicleType}
            // twoTanks={twoTanks}
            // setTwoTanks={setTwoTanks}
            // kmType={kmType}
            // setKmType={setKmType}
            // makeValue={makeValue}
            // setMakeValue={setMakeValue}
            // primaryTankID={primaryTankID}
            // setPrimaryTankID={setPrimaryTankID}
            // secondaryTankId={secondaryTankId}
            // setSecondaryTankId={setSecondaryID}
        />
    </CommonEdit>
)
}

export default VehicleEdit